<i18n>
{
  "cl": {
    "saludo": "Hola ",
    "ownedSince": "Dueño de tu 🏡 desde hace",
    "ownedSinceDays": "Dueño de tu 🏡 desde este mes!",
    "ownedSinceSME": "Financiando tu 🚀 desde hace",
    "ownedSinceDaysSME": "Financiando tu 🚀 desde este mes!",
    "ownedSinceParking": "Financiando tu 🅿️ desde hace",
    "ownedSinceDaysParking": "Financiando tu 🅿️ desde este mes!",
    "currentFeeFalse": "Al día",
    "isForDue": "Cuota disponible",
    "currentFeeTrue": "Por vencer",
    "isDefaulter": "Morosa",
    "isJudicial": "Por comenzar cobranza judicial",
    "of": " de ",
    "dues": " cuotas",
    "mortgageMonetaryValue": "UF ",
    "complementaryMonetaryValue": "$ ",
    "insolute": "Saldo:",
    "fireInsurance": "Seguro de incendio/sismo:",
    "lifeInsurance": "Seguro de desgravamen:",
    "creditInsurance": "Seguro de crédito:",
    "disabilityInsurance": "Seguro de invalidez:",
    "unemploymentInsurance": "Seguro de cesantía:",
    "insurances": "Seguros asociados",
    "mortgage": "Hipotecario 🏡 ",
    "complementary": "Complementario 💰",
    "sme": "PYME 🚀",
    "parking": "Consumo 🛍️",
    "creditName": "Crédito: ",
    "singleYear": " año",
    "pluralYear": " años",
    "singleMonth": " mes",
    "pluralMonth": " meses",
    "and": " y ",
    "errorMessage": "No hemos podido obtener datos sobre tu crédito",
    "pay-here": "Pagar"
  }
}
</i18n>

<template>
  <div>
    <div v-if="$i18n.locale === 'pe'">
      <div v-if="$store.state.currentUser.user.rol !== 'CLIENT'" id="notPermissions">
        <p>Usted no tiene permisos para ver este menú. Consulte al equipo de desarrollo para más información.</p>
      </div>
    </div>
    <div v-if="$i18n.locale === 'br'">
      <div v-if="$store.state.currentUser.user.rol !== 'CLIENT'" id="notPermissions">
        <p>Você não tem permissão para visualizar este menu. Consulte a equipe de desenvolvimento para mais informações.</p>
      </div>
    </div>
    <div v-if="$i18n.locale === 'cl' & $store.state.currentUser.user.rol !== 'CLIENT'">
      <div id="notPermissions">
        <p>Usted no tiene permisos para ver este menú. Consulte al equipo de desarrollo para más información.</p>
      </div>
    </div>
    <section v-if="showResume" class="card-item mb-6">
      <div class="is-flex is-justify-content-space-between">
        <span class="is-flex mb-4">
          <span class="icon-item is-flex is-align-items-center is-justify-content-center">
            <i class="fa-solid fa-dollar-sign has-text-primary is-size-5" />
          </span>
          <span>
            <h4 class="has-text-grey has-text-weight-medium is-size-6">Mis créditos</h4>
          </span>
        </span>
        <b-button type="is-text" size="is-small" class="mt-2" @click="() => { $router.push({ name: 'credit-resume' }); }">Ver detalle</b-button>
      </div>
      <div
        v-for="(operation, i) in clientDataResume"
        :key="`operation${i}`"
        :class="['message-item', {'last-message': i === clientDataResume.length - 1}]">
        <div class="message-item-inner credit-resume-list is-flex is-justify-content-space-between my-2 p-2">
          <div>
            <p id="creditName" class="has-text-weight-medium is-size-6 my-1">{{ $t(operation.creditType?.toLowerCase()) }}</p>
          </div>
          <div class="my-1">
            <b-tag
              v-if="operation.judicial === true"
              rounded
              class="is-size-7"
              type="is-light is-danger">
              {{ $t('isJudicial') }}
            </b-tag>
            <b-tag v-if="operation.upToDate === true" rounded class="is-size-7" type="is-light is-primary">
              {{ $t('currentFeeFalse') }}
            </b-tag>
            <b-tag
              v-if="operation.forDue === true"
              rounded
              class="is-size-7"
              type="is-light is-primary">
              {{ $t('isForDue') }}
            </b-tag>
            <b-tag
              v-if="operation.overdue === true"
              rounded
              class="is-size-7"
              type="is-light is-danger">
              {{ $t('currentFeeTrue') }}
            </b-tag>
            <b-tag
              v-if="operation.defaulter === true"
              rounded
              class="is-size-7"
              type="is-light is-danger">
              {{ $t('isDefaulter') }}
            </b-tag>
          </div>
        </div>
      </div>
      <div class="is-flex is-justify-content-flex-end">
        <b-button rounded type="is-danger" size="is-small" class="mt-2" @click="() => { $router.push({ name: 'pay-here' }); }">{{ $t('pay-here') }}</b-button>
      </div>
    </section>
    <section v-if="$store.state.currentUser.user.rol === 'CLIENT' && !showResume" id="resume" class="card-item mb-6">
      <div id="operations">
        <div class="is-flex is-justify-content-space-between is-align-items-center px-4">
          <h2 v-if="welcomeDate.type === 'MORTGAGE'" class="has-text-grey has-text-weight-medium is-size-6">
            {{ welcomeDate.years === false && welcomeDate.months === false ? $t('ownedSinceDays') : $t('ownedSince') }}
            {{ welcomeDate.years && welcomeDate.years == 1 ? welcomeDate.years + $t('singleYear') : welcomeDate.years === false ? ''
              : welcomeDate.years + $t('pluralYear') }}{{ welcomeDate.years !== false && welcomeDate.months !== false ? $t('and') : '' }}
            {{ welcomeDate.months && welcomeDate.months == 1 ? welcomeDate.months + $t('singleMonth') : welcomeDate.months === false ? ''
              : welcomeDate.months + $t('pluralMonth') }}
          </h2>
          <h2 v-else-if="welcomeDate.type === 'SME'" class="has-text-grey has-text-weight-medium is-size-6">
            {{ welcomeDate.years === false && welcomeDate.months === false ? $t('ownedSinceDaysSME') : $t('ownedSinceSME') }}
            {{ welcomeDate.years && welcomeDate.years == 1 ? welcomeDate.years + $t('singleYear') : welcomeDate.years === false ? ''
              : welcomeDate.years + $t('pluralYear') }}{{ welcomeDate.years !== false && welcomeDate.months !== false ? $t('and') : '' }}
            {{ welcomeDate.months && welcomeDate.months == 1 ? welcomeDate.months + $t('singleMonth') : welcomeDate.months === false ? ''
              : welcomeDate.months + $t('pluralMonth') }}
          </h2>
          <h2 v-else-if="welcomeDate.type === 'PARKING'" class="has-text-grey has-text-weight-medium is-size-6">
            {{ welcomeDate.years === false && welcomeDate.months === false ? $t('ownedSinceDaysParking') : $t('ownedSinceParking') }}
            {{ welcomeDate.years && welcomeDate.years == 1 ? welcomeDate.years + $t('singleYear') : welcomeDate.years === false ? ''
              : welcomeDate.years + $t('pluralYear') }}{{ welcomeDate.years !== false && welcomeDate.months !== false ? $t('and') : '' }}
            {{ welcomeDate.months && welcomeDate.months == 1 ? welcomeDate.months + $t('singleMonth') : welcomeDate.months === false ? ''
              : welcomeDate.months + $t('pluralMonth') }}
          </h2>
          <b-button
            rounded
            class=""
            type="is-danger"
            size="is-small"
            @click="() => { $router.push({ name: 'pay-here' }); }">
            {{ $t('pay-here') }}
          </b-button>
        </div>
        <div class="box p-2 my-1">
          <div v-for="(operation, i) in clientDataResume" :key="`operation${i}`" :class="['message-item', {'last-message': i === clientDataResume.length - 1}]">
            <div class="message-item-inner p-3 my-1">
              <header>
                <div>
                  <div class="is-flex is-justify-content-space-between is-align-items-center">
                    <div class="is-flex is-align-items-center">
                      <div class="is-flex is-flex-direction-column">
                        <div>
                          <div class="is-flex is-align-items-center">
                            <p id="creditName" class="has-text-weight-medium is-size-6">{{ $t('creditName') + operation.companyOperationId }}</p>
                          </div>
                          <div class="is-flex is-align-items-center is-flex-wrap-wrap mt-2">
                            <b-tag id="creditType" rounded class="my-1" type="is-light mr-2">{{ $t(operation.creditType?.toLowerCase()) }}</b-tag>
                            <b-tag id="insolute" rounded class="my-1" type="is-light mr-2">
                              {{ $t('insolute') }} {{ operation.creditType === 'MORTGAGE' || operation.creditType === 'PARKING' ?
                                $t('mortgageMonetaryValue') : $t('complementaryMonetaryValue') }} {{ formatter.format(operation.balanceAmmount.toFixed(2)) }}
                            </b-tag>
                            <b-tag id="fee" rounded class="my-1" type="is-light mr-2">{{ operation.currentPaidFee + $t('of') + operation.termAsMonths + $t('dues') }}</b-tag>
                          </div>
                          <div class="is-flex is-align-items-center is-justify-content-space-between">
                            <b-tag
                              v-if="operation.judicial === true"
                              rounded
                              class="is-size-7 mt-3"
                              type="is-light is-danger">
                              {{ $t('isJudicial') }}
                            </b-tag>
                            <b-tag v-if="operation.upToDate === true" rounded class="is-size-7 mt-3" type="is-light is-primary">
                              {{ $t('currentFeeFalse') }}
                            </b-tag>
                            <b-tag
                              v-if="operation.forDue === true"
                              rounded
                              class="is-size-7 mt-3"
                              type="is-light is-primary">
                              {{ $t('isForDue') }}
                            </b-tag>
                            <b-tag
                              v-if="operation.overdue === true"
                              rounded
                              class="is-size-7 mt-3"
                              type="is-light is-danger">
                              {{ $t('currentFeeTrue') }}
                            </b-tag>
                            <b-tag
                              v-if="operation.defaulter === true"
                              rounded
                              class="is-size-7 mt-3"
                              type="is-light is-danger">
                              {{ $t('isDefaulter') }}
                            </b-tag>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <b-button
                        v-if="hasInsuranceAvailable(operation)"
                        id="insurancesClick"
                        class="toggleButton is-rounded ml-2"
                        size="is-small"
                        @click="toggleCollapse(i)">
                        <i :class="{ 'fa-angle-down': !collapseStates[i], 'fa-angle-up': collapseStates[i]}" class="fas" aria-hidden="true" />
                      </b-button>
                    </div>
                  </div>
                </div>
              </header>
            </div>
            <div>
              <b-collapse
                v-if="hasInsuranceAvailable(operation)"
                class="message-body"
                animation="slide"
                :open="collapseStates[i]">
                <div class="content-insurance mt-1 mb-3 p-4">
                  <div v-if="operation.debtorLifeInsuranceType" class="is-flex is-flex-wrap-wrap">
                    <p id="insurancesType" class="is-size-7 has-text-grey has-text-weight-semibold">
                      {{ operation.debtorLifeInsuranceType ? getlifeInsuranceLabel(operation.debtorLifeInsuranceType) : '' }}
                    </p>
                    <p id="insurancesName" class="is-size-7 has-text-grey ml-1">
                      {{ operation.debtorLifeInsuranceTypeName }}
                    </p>
                  </div>
                  <div v-if="operation.fireInsuranceType" class="is-flex is-flex-wrap-wrap">
                    <p id="insurancesType" class="is-size-7 has-text-grey has-text-weight-semibold">
                      {{ operation.fireInsuranceType ? $t('fireInsurance') : '' }}
                    </p>
                    <p id="insurancesName" class="is-size-7 has-text-grey ml-1">
                      {{ operation.fireInsuranceTypeName }}
                    </p>
                  </div>
                  <div v-if="operation.creditInsuranceType" class="is-flex is-flex-wrap-wrap">
                    <p id="insurancesType" class="is-size-7 has-text-grey has-text-weight-semibold">
                      {{ operation.creditInsuranceType ? $t('creditInsurance') : '' }}
                    </p>
                    <p id="insurancesName" class="is-size-7 has-text-grey ml-1">
                      {{ operation.creditInsuranceTypeName }}
                    </p>
                  </div>
                  <div v-if="operation.unemploymentInsuranceType" class="is-flex is-flex-wrap-wrap">
                    <p id="insurancesType" class="is-size-7 has-text-grey has-text-weight-semibold">
                      {{ operation.unemploymentInsuranceType ? $t('unemploymentInsurance') : '' }}
                    </p>
                    <p id="insurancesName" class="is-size-7 has-text-grey ml-1">
                      {{ operation.unemploymentInsuranceTypeName }}
                    </p>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getClientResumeByClientId } from '@/application/services/api-clients/clients';
import notification from '@/ui/mixins/notification';

export default {
  name: 'CreditResume',
  mixins: [notification],
  props: { showResume: { type: Boolean, default: false } },
  data() {
    return {
      clientDataResume: [],
      clientName: this.$store.state.currentUser.user.name,
      welcomeDate: '',
      today: new Date(),
      formatter: new Intl.NumberFormat('de-DE'),
      collapseStates: []
    };
  },
  computed: {
    statusStyle() {
      if (this.clientDataResume.creditStatus === true) {
        return 'withDebt';
      }
      return 'withoutDebt';
    }
  },
  watch: {
  // Observa por cambios en clientDataResume
    clientDataResume: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.collapseStates = newValue?.map(() => false);
      }
    }
  },
  async created() {
    let clientData;
    try {
      clientData = await getClientResumeByClientId(this.$store.state.currentUser.user.clientId);
      this.clientDataResume = await clientData;
      this.welcomeDate = await this.welcomeTime();
    } catch (_error) {
      this.alert({ message: this.$t('errorMessage') });
    }
  },
  methods: {
    // TODO: Remover este hack cuando se tenga llave debtorDisabilityInsuranceType
    getlifeInsuranceLabel(debtorLifeInsuranceType) {
      if (debtorLifeInsuranceType.includes('disability')) {
        return this.$t('disabilityInsurance');
      }
      return this.$t('lifeInsurance');
    },
    welcomeTime() {
      const clientSignatureDate = this.clientDataResume[0].signatureDate;
      const elapsedTime = this.today - new Date(clientSignatureDate);
      const months = 86400000 * 30.416666666666668; // cantidad de segundos en un mes * un promedio de dias al mes
      const elapsedMonths = Math.floor(elapsedTime / months);
      const resultYears = Math.floor(elapsedMonths / 12);
      const resultMonths = elapsedMonths - (12 * resultYears);
      return {
        months: resultMonths >= 1 ? resultMonths : false,
        years: resultYears >= 1 ? resultYears : false,
        type: this.clientDataResume[0].creditType
      };
    },
    hasInsuranceAvailable(operation) {
      const stringToCheck = 'No insurance company available for';
      return operation.unemploymentInsuranceTypeName
      || [operation.fireInsuranceTypeName, operation.debtorLifeInsuranceTypeName].some(property => !property?.includes(stringToCheck));
    },
    toggleCollapse(i) {
      // Cambiar el estado de apertura para el b-collapse específico, basado en el índice
      this.$set(this.collapseStates, i, !this.collapseStates[i]);
    }
  }

};
</script>

<style scoped>
.message-item-inner:hover {
  background-color: #f8f8f8ad;
  border-radius: 10px;
}

.message-item {
  border-bottom: 0.1rem solid #f0f0f0;
}

.last-message {
  border: none;
}

.message-body {
  padding: 0;
  border: none;
}
.message-body .content-insurance {
  padding: 0;
  border: 0.2px solid #f0f0f0;
  border-radius: 0.5rem;
  background-color: #ffffffad;
}

@media (max-width: 520px) {
  .credit-resume-list {
    flex-direction: column;
  }
}
</style>
